<script>

import mapStylesDefault from '../vendor/google-map-snazzymaps';

import { 
    createMap, 
    createMarker, 
    fitMapBounds, 
    createInfoWindow,
    mapPinIcon,
    setMarkerIcon,
} from '../helpers/mapUtils';

import { MarkerClusterer } from "@googlemaps/markerclusterer";


const toCamelCase = val => {
    val = val
        .toLowerCase()
        .replace(/(?:(^.)|([-_\s]+.))/g, (match) => {
            return match.charAt(match.length-1).toUpperCase();
        });
    return val.charAt(0).toLowerCase() + val.substring(1);
};

const round = (number, precision) => {
    const factor = Math.pow(10, precision);
    const tempNumber = number * factor;
    const roundedTempNumber = Math.round(tempNumber);
    return roundedTempNumber / factor;
};

export default {
    props: {
        regionId: false,
        clustered: {
            type: Boolean,
            default: true
        },
        isActive: {
            type: Boolean,
            default: false
        },
        tabInit: {
            type: String,
            default: 'new-homes'
        },
        infoWindows: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        cities: [],
        newHomeCommunities: [],
        rentalCommunities: [],
        markers: [],
        loaded: false,
        mobileMapToggle: false,
        gm: undefined,
        mapInstance: undefined,
        markerCluster: undefined,
        infoWindow: undefined,
        tab: 'new-homes'
    }),
    computed: {
        mapStyles() {
            return mapStylesDefault;
        },
        communities() {
            return this.tab === 'new-homes'
                ? this.newHomeCommunities
                : this.rentalCommunities;
        }
    },
    created() {
        this.tab = this.tabInit;
    },
    watch: {
        communities: async function() {
            console.log("entro la primera vez")
            this.markers.forEach((marker) => marker.map = null);
            this.markers = [];
            if (this.gm) {
              await  this.setCommunityMarkers();
                if (this.clustered) {
                  await  this.initClusterer();
                }
            }
        }
    },
    mounted() {
        events.$on("map-intialized", (map) => {
            // loadMarkerClustererScript().then(() => {
                this.handleMapReady();
            // });
        });
        this.$eventsBus.$on('where-we-build-tabbed', this.handleTabToggle);
        this.$eventsBus.$on('community-card-over', this.handleCardOver);
        this.$eventsBus.$on('community-card-out', this.handleCardOut);
    },
    beforeDestroy() {
        this.$eventsBus.$off('where-we-build-tabbed', this.handleTabToggle);
        this.$eventsBus.$off('community-card-over', this.handleCardOver);
        this.$eventsBus.$off('community-card-out', this.handleCardOut);
    },
    methods: {
       async setCommunityMarkers() {
            this.communities.map(this.communityMarker);
        },
        async handleMapReady(map) {
            this.gm = google.maps;
            this.mapInstance = await createMap('wwb-map', {
                center: {lat: 37.7749, lng: -122.4194},
                zoom: 10,
                // styles: this.mapStyles
            });
           

            // this.homes.forEach(this.setMarker);
            this.findCommunities();
            this.infoWindow = createInfoWindow({
                maxWidth: 350
            });
            this.initClusterer();
            this.loaded = true;

            // this.mapInstance = map;
            // this.isReady = true;
            // this.$gmaps().then((gm) => {
            //     this.gm = gm;
            //     this.mapInstance.setZoom(10);
            //     this.mapInstance.setCenter({lat: 37.7749, lng: -122.4194});
            //     this.findCommunities();
            //     if (this.infoWindows) {
            //         this.infoWindow = new this.gm.InfoWindow({
            //             maxWidth: 350
            //         });
            //         this.gm.event.addListener(this.infoWindow, 'domready', this.setInfoWindowStyle);
            //     }
            // });
        },
        handleTabToggle(tab) {
            this.tab = tab;
            this.$eventsBus.$emit('where-we-build-map-tabbed', this.tab);
        },
        handleTabActive(item) {
            if (item === 'map') {
                this.findCommunities();
            }
        },
        setInfoWindowStyle() {
            const infoWindowOuter = $('.gm-style-iw');
            const infoWindowBkgd = infoWindowOuter.prev();
            const infoWindowTail = infoWindowBkgd.children(':nth-child(3)');

            // Hide the shadows
            infoWindowBkgd.children(':nth-child(2)').css({display: 'none'});
            infoWindowBkgd.children(':first-child').css({display: 'none'});

            // Style the background
            infoWindowBkgd.children(':nth-child(4)').css({
                boxShadow: '0 0 14px 0 rgba(0,0,0,0.2)',
                borderRadius: '0'
            });

            // Tail
            infoWindowTail.css({
                transformOrigin: 'top center',
                transform: 'scale(0.7, 0.75)'
            });

        },
        mapPinIcon(icon) {
            return this.gm.Size ? {
                url: icon,
                scaledSize: new this.gm.Size(26, 40),
                origin: new this.gm.Point(0, 0),
                anchor: new this.gm.Point(35, 70)
            } : {
                url: icon
            };
        },
        isMarkerClustered(marker) {
            // Map will be null if marker is clustered
            const found = marker.getMap();
            return found === null;
        },
        getCluster(id) {
            const clusters = this.markerCluster.clusters_;
            return clusters.find((c) => !!c.markers_.find((m) => m.id === `marker_${id}`));
        },
        handleCardOver(id) {
            const marker = this.markers.find((obj) => obj.id === `marker_${id}`);
            if (this.loaded && this.isMarkerClustered(marker) && this.getCluster(id)) {
                const cluster = this.getCluster(id);
                const div = cluster.clusterIcon_.div_;
                div.querySelector('img').src = '/images/site/maps/pin-compound-hover.svg';
                div.querySelector('div').style.color = '#092a49';
            }
            if (marker) {
                const icon = this.mapPinIcon(marker.pinHover);
                this.gm.event.trigger(marker, marker.setIcon(icon));
                marker.setZIndex(this.gm.Marker.MAX_ZINDEX + 1);
            }
        },
        handleCardOut(id) {
            const marker = this.markers.find((obj) => obj.id === `marker_${id}`);
            if (this.loaded && this.isMarkerClustered(marker) && this.getCluster(id)) {
                const cluster = this.getCluster(id);
                const div = cluster.clusterIcon_.div_;
                div.querySelector('img').src = '/images/site/maps/pin-compound.svg';
                div.querySelector('div').style.color = '#fff';
            }
            if (marker) {
                const icon = this.mapPinIcon(marker.pin);
                this.gm.event.trigger(marker, marker.setIcon(icon));
                marker.setZIndex(this.gm.Marker.MAX_ZINDEX);
            }
        },
        communityPopoverContent(community) {
            return Tortilla.Xhr.get(
                `/components/new-home-community-popover/${community.id}`
            ).then((res) => res.data);
        },
        getMarker(latitude, longitude) {
            const lat = round(latitude, 6);
            const lng = round(longitude, 6);
            const res = this.markers.filter((m) => {
                const mLat = round(m.position.lat(), 6);
                const mLng = round(m.position.lng(), 6);
                return mLat === lat && mLng === lng;
            });
            return res.length === 1 ? res[0] : false;
        },
        async communityMarker(community) {
            const lat = round(community.latitude, 6);
            const lng = round(community.longitude, 6);
            // const pin = this.tab === 'rental'
            //     ? '/images/site/maps/pin-rental.svg'
            //     : `/images/site/maps/pin-${community.availability}.svg`;
                // const pinHover = '/images/site/maps/pin-hover.svg'
            const pin = this.tab === 'rental'
                ? 'pin-rental'
                : `pin-${community.availability}`;
            const pinHover = 'pin-hover'
            const template = this.getTemplate(community);

            // let marker = this.getMarker(lat, lng);

            if (!(lat && lng)) return false;

            // if (!marker) {
            //    const marker = new this.gm.Marker({
            //         map: this.mapInstance,
            //         pin: pin,
            //         pinHover: pinHover,
            //         icon: {
            //             url: pin,
            //             scaledSize: new this.gm.Size(26, 40),
            //             origin: new this.gm.Point(0, 0),
            //             anchor: new this.gm.Point(35, 70)
            //         },
            //         optimized: false,
            //         position: {lat: lat, lng: lng},
            //         id: `marker_${community.id}`,
            //         property_type: {
            //             total: 1,
            //             key: community.property_type,
            //             title: community.property_type_title
            //         },
            //         content: template
            //     });

                const marker = await createMarker({
                    map: this.mapInstance,
                    position: { lat: lat, lng: lng },
                    size:{ width: 30, height: 40 },
                    icon: mapPinIcon(pin),
                    title: community.property_type_title,
                    className: 'custom-marker',
                    id: `marker_${community.id}` 
                });

                marker.content.addEventListener('mouseover', () => {
                    this.handleMarkerOver(marker.id);
                    // marker.setIcon(this.mapPinIcon(marker.pinHover));
                    // marker.setZIndex(this.gm.Marker.MAX_ZINDEX + 1);
                    const icon = mapPinIcon(pinHover);
                    if (marker) setMarkerIcon(marker, icon);

                    marker.content.style.zIndex = this.gm.Marker.MAX_ZINDEX + 1;
                });
                marker.content.addEventListener('mouseout', () => {
                    this.handleMarkerOut(marker.id);
                    // marker.setIcon(this.mapPinIcon(marker.pin));
                    // marker.setZIndex(this.gm.Marker.MAX_ZINDEX);
                    const icon = mapPinIcon(pin);
                    if (marker) setMarkerIcon(marker, icon);

                    marker.content.style.zIndex = this.gm.Marker.MAX_ZINDEX + 1;
                });
                marker.addListener('click', () => {
                    this.handleMarkerClick(marker.id);
                    if (this.infoWindows) {
                        this.infoWindow.close();
                        this.infoWindow.setContent(template);
                        this.infoWindow.open(this.mapInstance, marker);
                        // this.mapInstance.panTo(marker.getPosition());
                    }
                });
                 this.markers.push(marker);
                fitMapBounds(this.mapInstance, this.markers, 13);
                return marker;
            // }
        },
        setCommunities(response) {
            this.newHomeCommunities = response.data.newHomeCommunities;
            this.rentalCommunities = response.data.rentalCommunities;
            this.loaded = true;
        },
        findCommunities() {
            return Tortilla.Xhr.get('/api/where-we-build').then(this.setCommunities);
        },
        getMarkerTypes(markers) {
            const types = {};
            markers.forEach((marker) => {
                if (!(marker.property_type.key in types)) {
                    types[marker.property_type.key] = {
                        total: marker.property_type.total,
                        title: marker.property_type.title
                    };
                } else {
                    types[marker.property_type.key].total += marker.property_type.total;
                }
            });
            return types;
        },
        handleMarkerOver(id) {
            this.$eventsBus.$emit('marker-over', id);
        },
        handleMarkerOut(id) {
            this.$eventsBus.$emit('marker-out', id);
        },
        handleMarkerClick(id) {
            this.$eventsBus.$emit('marker-click', id);
        },
       async initClusterer() {
            // clear the cluster markers if it exists to ensure that multiple marker
            // clusters don't exist for the same or much of the same markers
            if (this.markerCluster) {
                this.markerCluster.clearMarkers();
            }
            // this.markerCluster = new MarkerClusterer(this.mapInstance, this.markers, {
            //     maxZoom: 12,
            //     minimumClusterSize: 2,
            //     averageCenter: true,
            //     styles: [{
            //         textColor: 'white',
            //         textSize: 13,
            //         url: '/images/site/maps/pin-compound.svg',
            //         height: 50,
            //         width: 46,
            //         backgroundPosition: 'center 10px'
            //     }]
            // });

            this.markerCluster = new MarkerClusterer({
                markers: this.markers,
                map: this.mapInstance,
                renderer: {
                    render: ({ count, position }) => {
                        const marker = new google.maps.Marker({
                            position,
                            icon: {
                                url: '/images/site/maps/pin-compound.svg', 
                                scaledSize: new google.maps.Size(46, 50),
                                labelOrigin: new google.maps.Point(22, 18)
                            },
                            label: {
                                text: String(count),
                                color: 'white',
                                fontSize: '13px',
                                fontWeight: '700',
                            }
                        });
                        return marker;
                    }
                }
            });
            console.log(this.markerCluster);
            fitMapBounds(this.mapInstance, this.markers, 13);
        },
        getTemplate(community) {
            return `<div class="wwb__flyout">
                <div class="wwb__flyout-logo">
                    <img alt="${community.name} logo" src="${community.images.logo.medium}">
                </div>
                <div class="wwb__flyout-data">${community.name}</div>
                <div class="wwb__flyout-cta">
                    <a href="${community.url}" class="cta cta--yelling cta--heavy cta--primary wwb__flyout-cta-button">
                        <div class="cta__inner">
                            <div class="cta__pointer-container cta__pointer-container-left">
                                <div class="cta__pointer"></div>
                            </div>
                            <div class="cta__pointer-container cta__pointer-container-right">
                                <div class="cta__pointer"></div>
                            </div>
                        </div>
                        <div class="cta__content">Visit</div>
                    </a>
                </div>
            </div>`;
        }
    }
};
</script>

<style>
    #wwb-map {
        height: 100%;
        width: 100%;
        z-index: 1;
        position: absolute;
    }
</style>
